import { ReactElement, Suspense, lazy } from 'react';

import ErrorBoundary from '../components/ErrorBoundary';
import RouteSkeleton from '../components/RouteSkeleton';

export const childPath = (absolutePath: string) => absolutePath.replace(/^\//, '');

export const RouteFallback = () => <RouteSkeleton />;

export const route = (element: ReactElement) => (
  <ErrorBoundary>
    <Suspense fallback={<RouteFallback />}>
      {element}
    </Suspense>
  </ErrorBoundary>
);

export const HomePage = lazy(() =>
  import('../../features/home/pages/HomePage').then((m) => ({ default: m.HomePage }))
);
export const ComingSoonPage = lazy(() =>
  import('../../features/home/pages/ComingSoonPage').then((m) => ({ default: m.ComingSoonPage }))
);
export const CustomerPage = lazy(() => import('../../features/customer/pages/CustomerPage'));
export const ShopPageRoute = lazy(() => import('../../features/shopper/pages/ShopPageRoute'));
export const ProductPage = lazy(() => import('../../features/products/pages/ProductPage'));
export const CustomerCardSetupPage = lazy(() =>
  import('../../features/paymentMethods/pages/CustomerCardSetupPage')
);
export const PrivacyPage = lazy(() => import('../../features/legal/pages/PrivacyPage'));
export const RefundsPage = lazy(() => import('../../features/legal/pages/RefundsPage'));
export const StorePolicyPage = lazy(() => import('../../features/legal/pages/StorePolicyPage'));
export const TermsPage = lazy(() => import('../../features/legal/pages/TermsPage'));
export const DriverAgreementPage = lazy(() => import('../../features/legal/pages/DriverAgreementPage'));
export const CodeOfConductPage = lazy(() => import('../../features/legal/pages/CodeOfConductPage'));
export const PaymentCancelPage = lazy(() => import('../../features/payments/pages/PaymentCancelPage'));
export const PaymentResultPage = lazy(() => import('../../features/payments/pages/PaymentResultPage'));
export const PaymentSuccessPage = lazy(() => import('../../features/payments/pages/PaymentSuccessPage'));
export const AdminPage = lazy(() => import('../../features/admin').then((m) => ({ default: m.AdminPage })));
export const ScannerPage = lazy(() => import('../../features/scanner/pages/ScannerPage'));
export const SharedStatusPage = lazy(() =>
  import('../../features/shared/pages/SharedStatusPage').then((m) => ({ default: m.SharedStatusPage }))
);
export const OrderTrackingPage = lazy(() => import('../../features/orders/pages/OrderTrackingPage'));
export const CheckoutPage = lazy(() => import('../../features/orders/pages/CheckoutPage'));
export const ForbiddenPage = lazy(() => import('../../features/auth/pages/ForbiddenPage'));
export const ResetPasswordPage = lazy(() => import('../../features/auth/pages/ResetPasswordPage'));
export const SignUpPage = lazy(() => import('../../features/auth/pages/SignUpPage'));
export const AffiliateSignUpPage = lazy(() => import('../../features/affiliates/pages/AffiliateSignUpPage').then((m) => ({ default: m.AffiliateSignUpPage })));
export const VerifyEmailPage = lazy(() => import('../../features/auth/pages/VerifyEmailPage'));
export const LoginPage = lazy(() => import('../../features/auth/pages/LoginPage'));
export const ApproveTeenLinkPage = lazy(() => import('../../features/auth/pages/ApproveTeenLinkPage'));
export const AmpPage = lazy(() => import('../../features/amp/pages/AmpPage'));
export const SupportPage = lazy(() => import('../../features/support/pages/SupportPage'));
export const DriverOnboardingPage = lazy(() => import('../../features/driver/pages/DriverOnboardingPage'));
export const AboutPage = lazy(() => import('../../features/legal/pages/AboutPage'));
export const HowItWorksPage = lazy(() => import('../../features/legal/pages/HowItWorksPage'));
export const FaqPage = lazy(() => import('../../features/legal/pages/FaqPage'));
export const BottleReturnsPage = lazy(() => import('../../features/legal/pages/BottleReturnsPage'));
export const ObservabilityPage = lazy(() =>
  import('../../features/observability').then((m) => ({ default: m.ObservabilityPage }))
);

